function closeModal(state) {
    if (!state.modal) {
        return;
    }

    if (typeof state.modal.close === 'function') {
        state.modal.close();
    } else {
        state.modal.removeAttribute('open');
    }

    state.modal.classList.remove('is-visible');
    state.modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';

    if (state.lastTrigger) {
        state.lastTrigger.setAttribute('aria-expanded', 'false');
        state.lastTrigger.focus();
    }
}

function updateCaption(state) {
    if (!state.captionElement || !state.slides[state.currentSlideIndex]) {
        return;
    }

    state.captionElement.textContent = state.slides[state.currentSlideIndex].caption;
}

function updateDotsDisplay(state) {
    state.dotsContainer.querySelectorAll('.insp-dot').forEach(function (dot, index) {
        var isActive = index === state.currentSlideIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
}

function updateSlideDisplay(state) {
    state.carousel.querySelectorAll('.insp-slide').forEach(function (slide, index) {
        var isActive = index === state.currentSlideIndex;
        slide.classList.toggle('is-active', isActive);
        slide.hidden = !isActive;
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });
}

function goToSlide(state, index) {
    if (index < 0 || index >= state.slides.length) {
        return;
    }

    state.currentSlideIndex = index;
    updateSlideDisplay(state);
    updateDotsDisplay(state);
    updateCaption(state);
}

function renderDots(state) {
    state.dotsContainer.innerHTML = '';

    state.slides.forEach(function (_, index) {
        var dotItem = document.createElement('li');
        var dot = document.createElement('button');

        dot.className = 'insp-dot';
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
        dot.addEventListener('click', function () {
            goToSlide(state, index);
        });

        dotItem.appendChild(dot);
        state.dotsContainer.appendChild(dotItem);
    });
}

function renderCarousel(state) {
    state.carousel.innerHTML = '';

    state.slides.forEach(function (slide, index) {
        var slideDiv = document.createElement('div');
        var img = document.createElement('img');

        slideDiv.className = 'insp-slide';
        slideDiv.hidden = index !== 0;
        slideDiv.setAttribute('aria-hidden', index === 0 ? 'false' : 'true');

        img.src = slide.src;
        img.alt = slide.alt;
        slideDiv.appendChild(img);

        state.carousel.appendChild(slideDiv);
    });

    renderDots(state);
    updateDotsDisplay(state);
    updateCaption(state);
}

function openModal(state, card, trigger) {
    var imageElement = card.querySelector('.insp-image');
    var captionText = card.querySelector('.insp-caption');

    if (!imageElement) {
        return;
    }

    state.lastTrigger = trigger;
    state.slides = [{
        src: imageElement.src,
        alt: imageElement.alt,
        caption: captionText ? captionText.textContent : ''
    }];
    state.currentSlideIndex = 0;

    renderCarousel(state);

    if (typeof state.modal.showModal === 'function') {
        state.modal.showModal();
    } else {
        state.modal.setAttribute('open', 'open');
    }

    state.modal.classList.add('is-visible');
    state.modal.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
}

export function initInspirationGalleryGrid(root = document) {
    root.querySelectorAll('.insp-gallery-grid[data-insp-gallery-root]:not([data-insp-bound])').forEach(function (grid) {
        var galleryId = grid.getAttribute('data-insp-gallery-root');
        var modal = document.querySelector('.insp-modal[data-insp-gallery-modal="' + galleryId + '"]');
        var buttons = grid.querySelectorAll('.insp-btn');

        if (!modal || !buttons.length) {
            return;
        }

        grid.dataset.inspBound = 'true';

        var state = {
            modal: modal,
            carousel: modal.querySelector('.insp-carousel'),
            dotsContainer: modal.querySelector('.insp-dots'),
            captionElement: modal.querySelector('.insp-caption'),
            currentSlideIndex: 0,
            slides: [],
            lastTrigger: null
        };

        buttons.forEach(function (button) {
            if (button.dataset.inspBound === 'true') {
                return;
            }

            button.dataset.inspBound = 'true';
            button.setAttribute('aria-expanded', 'false');

            button.addEventListener('click', function () {
                var card = button.closest('.insp-grid-item');
                if (card) {
                    openModal(state, card, button);
                }
            });
        });

        modal.querySelector('.insp-nav-prev').addEventListener('click', function () {
            var nextIndex = state.currentSlideIndex - 1;
            if (nextIndex < 0) {
                nextIndex = state.slides.length - 1;
            }

            goToSlide(state, nextIndex);
        });

        modal.querySelector('.insp-nav-next').addEventListener('click', function () {
            var nextIndex = state.currentSlideIndex + 1;
            if (nextIndex >= state.slides.length) {
                nextIndex = 0;
            }

            goToSlide(state, nextIndex);
        });

        modal.querySelector('.insp-close').addEventListener('click', function () {
            closeModal(state);
        });

        modal.querySelector('.insp-modal-overlay').addEventListener('click', function () {
            closeModal(state);
        });

        modal.addEventListener('cancel', function () {
            closeModal(state);
        });

        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape' && modal.classList.contains('is-visible')) {
                closeModal(state);
            }
        });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
        initInspirationGalleryGrid();
    });
} else {
    initInspirationGalleryGrid();
}
